import { StickyNote2Outlined } from "@mui/icons-material";
import { Box, Button, Stack } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { ItemProperty, TextEditor, TextEditorRef, TextViewer } from "src/components";

interface Props {
  note: string | null;
  userCanEdit: boolean;
  disabled?: boolean;
  onSaveClicked: (note: string) => void;
  onCancelClicked?: () => void;
}

const NoteProperty = (props: Props) => {
  const [isEditing, setIsEditing] = useState(false);
  const [note, setNote] = useState(props.note ?? "");
  const editorRef = useRef<TextEditorRef | null>(null);

  useEffect(() => {
    if (isEditing) {
      editorRef.current?.focus();
    }
  }, [isEditing]);

  function handleSaveClicked() {
    setIsEditing(false);
    props.onSaveClicked(note);
  }

  function handleCancelClicked() {
    setIsEditing(false);
    props.onCancelClicked?.();
  }

  return (
    <ItemProperty
      labelIcon={<StickyNote2Outlined />}
      label="Notes"
      canEdit={props.userCanEdit}
      isEditing={isEditing}
      onEditClicked={() => setIsEditing(true)}
    >
      <Box sx={{ display: "flex" }}>
        {isEditing ? (
          <Stack spacing={0.5} sx={{ flex: 1 }}>
            <TextEditor ref={editorRef} initialValue={props.note ?? ""} onChange={(value) => setNote(value)} />
            <Stack direction="row" spacing={0.5} sx={{ justifyContent: "flex-end" }}>
              <Button variant="text" disabled={props.disabled} onClick={handleCancelClicked}>
                Cancel
              </Button>
              <Button variant="tertiary" disabled={props.disabled} onClick={handleSaveClicked}>
                Save
              </Button>
            </Stack>
          </Stack>
        ) : (
          <TextViewer placeholder={props.userCanEdit ? "Enter details..." : "No notes"} value={props.note ?? ""} />
        )}
      </Box>
    </ItemProperty>
  );
};

export { NoteProperty };
